import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ExternalLink } from "lucide-react";
import { CalendarTab } from "@/components/vigilanza/CalendarTab";
import { PeopleTab } from "@/components/vigilanza/PeopleTab";
import { SlotsTab } from "@/components/vigilanza/SlotsTab";
import { ExclusionsTab } from "@/components/vigilanza/ExclusionsTab";
import { PublicTab } from "@/components/vigilanza/PublicTab";

export default function Vigilanza() {
  const { data: slots = [] } = useQuery({ queryKey: ["vig-slots"], queryFn: async () => (await api.get("/vigilanza/slots")).data });
  const { data: people = [] } = useQuery({ queryKey: ["vig-people"], queryFn: async () => (await api.get("/vigilanza/people")).data });
  const { data: exclusions = [] } = useQuery({ queryKey: ["vig-exclusions"], queryFn: async () => (await api.get("/vigilanza/exclusions")).data });

  return (
    <div className="p-4 sm:p-6 md:p-10 max-w-[1200px] mx-auto" data-testid="vigilanza-page">
      <PageHeader
        title="Turni Vigilanza"
        subtitle="Fasce orarie, persone in turno (studenti del 3° anno, membri di Classroom, nomi liberi), giorni esclusi e rotazione automatica."
        actions={<a href="/turni" target="_blank" rel="noreferrer"><Button variant="outline" data-testid="vig-open-public"><ExternalLink size={14} className="mr-1"/> Pagina pubblica /turni</Button></a>}
      />
      <Tabs defaultValue="calendar">
        <TabsList className="flex-wrap h-auto">
          <TabsTrigger value="calendar" data-testid="vig-tab-calendar">Calendario</TabsTrigger>
          <TabsTrigger value="people" data-testid="vig-tab-people">Persone ({people.length})</TabsTrigger>
          <TabsTrigger value="slots" data-testid="vig-tab-slots">Fasce orarie</TabsTrigger>
          <TabsTrigger value="exclusions" data-testid="vig-tab-exclusions">Giorni esclusi</TabsTrigger>
          <TabsTrigger value="public" data-testid="vig-tab-public">Pagina pubblica</TabsTrigger>
        </TabsList>
        <TabsContent value="calendar"><CalendarTab slots={slots} people={people} exclusions={exclusions}/></TabsContent>
        <TabsContent value="people"><PeopleTab slots={slots} people={people}/></TabsContent>
        <TabsContent value="slots"><SlotsTab slots={slots}/></TabsContent>
        <TabsContent value="exclusions"><ExclusionsTab slots={slots} exclusions={exclusions}/></TabsContent>
        <TabsContent value="public"><PublicTab/></TabsContent>
      </Tabs>
    </div>
  );
}
